/* Joaninha consent: Shopify Customer Privacy API = fonte da verdade;
   localStorage = fallback de exibição (nunca deixa o usuário travado). */
(() => {
  'use strict';
  const KEY = 'joaninha-consent';
  const banner = document.querySelector('[data-consent-banner]');
  if (!banner) return;
  const status = banner.querySelector('[data-consent-status]');
  const buttons = [...banner.querySelectorAll('[data-consent-accept],[data-consent-reject]')];
  let loading, busy = false, opener;
  const setBusy = value => { busy = value; buttons.forEach(button => { button.disabled = value; }); banner.setAttribute('aria-busy', String(value)); };
  const store = value => { try { localStorage.setItem(KEY, value); return true; } catch (_) { return false; } };
  const cached = () => { try { return localStorage.getItem(KEY); } catch (_) { return null; } };
  function show(message = '') { banner.hidden = false; status.textContent = message; }
  function hide() { banner.hidden = true; status.textContent = ''; }
  function api() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const started = Date.now();
      function load() {
        if (typeof window.Shopify?.loadFeatures !== 'function') {
          if (Date.now() - started > 8000) return reject(new Error('Privacy unavailable'));
          return setTimeout(load, 150);
        }
        const timeout = setTimeout(() => reject(new Error('Privacy timeout')), 10000);
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          clearTimeout(timeout);
          if (error || !window.Shopify.customerPrivacy) reject(new Error('Privacy unavailable'));
          else resolve(window.Shopify.customerPrivacy);
        });
      }
      load();
    }).finally(() => { loading = null; });
    return loading;
  }
  const hasDecision = privacy => ['analytics', 'marketing', 'preferences'].every(key => ['yes', 'no'].includes(privacy.currentVisitorConsent()[key]));
  async function choose(accepted) {
    if (busy) return;
    setBusy(true); status.textContent = banner.dataset.saving;
    try {
      const privacy = await api();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Consent timeout')), 10000);
        privacy.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted }, error => {
          clearTimeout(timeout);
          const decision = privacy.currentVisitorConsent();
          if (error || !['analytics', 'marketing', 'preferences'].every(key => decision[key] === (accepted ? 'yes' : 'no'))) reject(new Error('Consent not confirmed'));
          else resolve();
        });
      });
      try { localStorage.removeItem(KEY); } catch (_) { /* API é autoritativa. */ }
      hide();
      if (opener?.isConnected) opener.focus();
    } catch (_) {
      /* FALLBACK: API indisponível (ex.: theme editor, bloqueio de terceiros).
         Salva localmente e oculta — nunca deixa o usuário preso no banner. */
      if (store(accepted ? 'accepted' : 'rejected')) hide();
      else show(banner.dataset.saveError);
    }
    finally { setBusy(false); }
  }
  banner.querySelector('[data-consent-accept]').addEventListener('click', () => choose(true));
  banner.querySelector('[data-consent-reject]').addEventListener('click', () => choose(false));
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-consent-open]');
    if (!control) return;
    event.preventDefault(); opener = control; show(); buttons[0].focus();
  });
  const cachedChoice = cached();
  api()
    .then(privacy => { if (!hasDecision(privacy) && !cachedChoice) show(); })
    .catch(() => { if (cachedChoice) hide(); else show(banner.dataset.loadError); });
})();
